import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "main-header"
}
const _hoisted_2 = { class: "header-top" }
const _hoisted_3 = { class: "device-info" }
const _hoisted_4 = { class: "device-title" }
const _hoisted_5 = { class: "status-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "status-text"
}
const _hoisted_7 = { class: "device-subtitle" }
const _hoisted_8 = { class: "device-id" }
const _hoisted_9 = {
  key: 0,
  class: "vin-display"
}
const _hoisted_10 = { class: "header-actions" }
const _hoisted_11 = { class: "vin-selection" }
const _hoisted_12 = { class: "vin-selector" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "vin-count" }
const _hoisted_15 = { class: "vin-actions" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "vin-selection" }
const _hoisted_18 = { class: "vin-selector" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "vin-count" }
const _hoisted_21 = { class: "vehicle-logs-wrapper" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "logs-badge"
}
const _hoisted_24 = {
  key: 0,
  class: "vehicle-logs-popover"
}
const _hoisted_25 = { class: "vehicle-logs-header" }
const _hoisted_26 = {
  key: 0,
  class: "vehicle-logs-list"
}
const _hoisted_27 = { class: "vehicle-log-top" }
const _hoisted_28 = { class: "vehicle-log-vin" }
const _hoisted_29 = { class: "vehicle-log-time" }
const _hoisted_30 = { class: "vehicle-log-text" }
const _hoisted_31 = {
  key: 1,
  class: "vehicle-logs-empty"
}
const _hoisted_32 = { class: "vin-actions" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "telemetry-content" }
const _hoisted_35 = { class: "section-block overview-section" }
const _hoisted_36 = { class: "overview-grid" }
const _hoisted_37 = {
  key: 1,
  class: "card span-2 vehicle-status"
}
const _hoisted_38 = { class: "status-grid" }
const _hoisted_39 = { class: "status-item" }
const _hoisted_40 = { class: "status-value" }
const _hoisted_41 = { class: "status-item" }
const _hoisted_42 = { class: "status-value" }
const _hoisted_43 = { class: "status-item" }
const _hoisted_44 = { class: "status-value" }
const _hoisted_45 = { class: "status-item" }
const _hoisted_46 = { class: "fuel-gauge" }
const _hoisted_47 = { class: "fuel-bar" }
const _hoisted_48 = { class: "fuel-percentage" }
const _hoisted_49 = { class: "status-item" }
const _hoisted_50 = { class: "status-value" }
const _hoisted_51 = { class: "card span-1 vehicle-info" }
const _hoisted_52 = { class: "info-grid" }
const _hoisted_53 = { class: "info-item" }
const _hoisted_54 = { class: "info-value" }
const _hoisted_55 = { class: "info-item" }
const _hoisted_56 = { class: "info-value" }
const _hoisted_57 = { class: "info-item" }
const _hoisted_58 = { class: "info-value" }
const _hoisted_59 = {
  key: 0,
  class: "dash-section charts-section"
}
const _hoisted_60 = { class: "section-header-main" }
const _hoisted_61 = { class: "telemetric-subtitle" }
const _hoisted_62 = { class: "charts-tab charts-block" }
const _hoisted_63 = { class: "charts-header" }
const _hoisted_64 = { class: "chart-controls" }
const _hoisted_65 = { class: "range-btn-group" }
const _hoisted_66 = {
  class: "date-range-selector",
  style: {"position":"relative"}
}
const _hoisted_67 = ["title"]
const _hoisted_68 = {
  key: 0,
  class: "calendar-popover-chart"
}
const _hoisted_69 = { class: "range-calendar-container" }
const _hoisted_70 = { class: "chart-container" }
const _hoisted_71 = {
  key: 1,
  class: "dash-section map-section"
}
const _hoisted_72 = { class: "map-component-stacked" }
const _hoisted_73 = {
  key: 2,
  class: "dash-section environment-section"
}
const _hoisted_74 = { class: "section-header-main" }
const _hoisted_75 = {
  class: "environment-container",
  style: {"padding":"16px"}
}
const _hoisted_76 = {
  key: 3,
  class: "dash-section stats-section"
}
const _hoisted_77 = { class: "stats-block" }

import axios from "@/axiosInstance";
	import HistoricalChart from "@/components/data/HistoricalChart.vue";
	import LocationCard from "@/components/data/LocationCard.vue";
	import RouteMap from "@/components/data/RouteMap.vue";
	import StatisticsPanel from "@/components/data/StatisticsPanel.vue";
	import NotificationBell from "@/components/NotificationBell.vue";
	import StatusDot from "@/components/ui/StatusDot.vue";
	import ViewToggle from "@/components/ViewToggle.vue";
	import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
	import { useRoute, useRouter } from "vue-router";
	import { useToast } from "vue-toast-notification";
	import LocationModal from "./data/LocationModal.vue";
	import MaterialCalendar from "./ui/MaterialCalendarRange.vue";

	import EnvironmentConfigModal from "@/components/data/EnvironmentConfigModal.vue";
	import EnvironmentSection from "@/components/data/EnvironmentSection.vue";
	import { useChartVisibility } from "@/composables/useChartVisibility";

	import { faSliders } from "@fortawesome/free-solid-svg-icons";
	import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

	
export default /*@__PURE__*/_defineComponent({
  __name: 'TelemetryPage',
  props: {
    headless: { type: Boolean },
    currentTempC: {},
    outsideHum: {},
    lastUpdateAgo: {},
    chartRangeMet: {},
    seriesT: {},
    seriesH: {},
    tempMin: {},
    tempMax: {},
    humMin: {},
    humMax: {},
    meteoLoading: { type: Boolean }
  },
  emits: ["refresh", "center", "copy-coords", "update:range", "location-update", "timestamp-update"],
  setup(__props: any, { emit: __emit }) {

	const route = useRoute();
	const router = useRouter();
	const toast = useToast();

	const showEnvConfig = ref(false);

	// Chart visibility
	const chartVisibility = useChartVisibility();

	// Props e stati
	const props = __props;

	const emit = __emit;

	const deviceId = computed(() => {
		const val = route.params.deviceId;
		const n = Number(val);
		return Number.isNaN(n) ? 0 : n;
	});

	const deviceName = ref("");
	const currentAddress = ref("");
	const lastGeocodedCoords = ref<string>("");
	const apiStatus = ref<"online" | "offline" | "maintenance" | "error">("offline");
	const loading = ref(false);
	const historicalLoading = ref(false); // loading separato per dati storici
	const showCoordModal = ref(false);
	const showChartCalendar = ref(false);
	const vehicleLogs = ref<any[]>([]);
	const showVehicleLogs = ref(false);

	// VIN Management
	const selectedVin = ref<string>("");
	const availableVins = ref<Array<{ vin: string }>>([]);

	// Dati
	const latestData = ref<any>(null);
	// chartData rimosso
	const historicalData = ref<any[]>([]); // Per grafici storici (basato su range)
	const routeLocations = ref<any[]>([]);
	const historicalRouteLocations = ref<any[]>([]); // <-- NUOVA variabile

	const stats = ref({
		total_records: 0,
		unique_vehicles: 0,
		latest_timestamp: 0,
		earliest_timestamp: 0,
	});

	// Configurazione grafici
	const selectedMetric = ref("speed");
	const chartRange = ref("24h");
	const chartTimeRange = ref<{ start: number; end: number } | null>(null);
	const startDate = ref<string>(""); // YYYY-MM-DD
	const endDate = ref<string>(""); // YYYY-MM-DD
	// const selectedDate = ref<string>(""); // YYYY-MM-DD

	// function onChartDateSelect(date: string) {
	//   selectedDate.value = date;
	//   showChartCalendar.value = false;
	//   endDate.value = date;
	//   // Solo per route/mappa, NON per environment charts
	//   chartRange.value = "custom";
	//   fetchHistoricalData("custom", true); // Questo carica solo i dati del percorso

	//   toast.info(`Percorso aggiornato fino al: ${formatDateDisplay(date)}`, {
	//     position: "top-right",
	//     duration: 3000,
	//   });
	// }

	// function onChartDateSelect(date: string) {
	//   // RouteMap seleziona un giorno → lo traduciamo in range custom di 1 giorno
	//   startDate.value = date;
	//   endDate.value = date;
	//   chartRange.value = "custom";
	//   showChartCalendar.value = false;

	//   refreshTimeWindow("custom");

	//   toast.info(`Percorso e grafico aggiornati al: ${formatDateDisplay(date)}`, {
	//     position: "top-right",
	//     duration: 3000,
	//   });
	// }

	function computeTimeWindow(range: string, endTimestampFallback?: number) {
	  const endTime = endTimestampFallback || Math.floor(Date.now() / 1000);
	  let startTime = 0;

	  if (range === "custom" && startDate.value && endDate.value) {
	    const s = new Date(startDate.value);
	    s.setHours(0, 0, 0, 0);
	    const e = new Date(endDate.value);
	    e.setHours(23, 59, 59, 999);

	    return {
	      startTime: Math.floor(s.getTime() / 1000),
	      endTime: Math.floor(e.getTime() / 1000),
	    };
	  }

	  switch (range) {
	    case "1h":
	      startTime = endTime - 60 * 60;
	      break;
	    case "24h":
	      startTime = endTime - 24 * 60 * 60;
	      break;
	    case "7d":
	      startTime = endTime - 7 * 24 * 60 * 60;
	      break;
	    case "30d":
	      startTime = endTime - 30 * 24 * 60 * 60;
	      break;
	    default:
	      startTime = endTime - 24 * 60 * 60;
	  }

	  return { startTime, endTime };
	}

	// Computed per display
	const getDateRangeDisplay = computed(() => {
		if (!startDate.value && !endDate.value) {
			return "Seleziona Data";
		}
		if (startDate.value === endDate.value) {
			return formatDateDisplay(startDate.value);
		}
		return `${formatDateDisplay(startDate.value)} - ${formatDateDisplay(endDate.value)}`;
	});

	const getDateRangeTitle = computed(() => {
		if (!startDate.value && !endDate.value) {
			return "Seleziona un range di date";
		}
		return `Dal ${startDate.value} al ${endDate.value}`;
	});

	const isDateRangeValid = computed(() => {
		if (!startDate.value || !endDate.value) return false;

		const start = new Date(startDate.value);
		const end = new Date(endDate.value);
		return start <= end;
	});

	// TelemetryPage.vue
	// const filteredRouteLocations = computed(() => {
	// 	// Se non ci sono date di range, mostra tutti i dati
	// 	if (!startDate.value || !endDate.value) {
	// 		return routeLocations.value;
	// 	}

	// 	// Converti date in timestamp
	// 	const startDateObj = new Date(startDate.value);
	// 	startDateObj.setHours(0, 0, 0, 0);
	// 	const startTimestamp = Math.floor(startDateObj.getTime() / 1000);

	// 	const endDateObj = new Date(endDate.value);
	// 	endDateObj.setHours(23, 59, 59, 999);
	// 	const endTimestamp = Math.floor(endDateObj.getTime() / 1000);

	// 	// Filtra i locations
	// 	// Filtra i locations e conta
	// 	const filtered = routeLocations.value.filter((loc) => {
	// 		const timestamp = typeof loc.timestamp === "string" ? parseInt(loc.timestamp, 10) : loc.timestamp;

	// 		return timestamp >= startTimestamp && timestamp <= endTimestamp;
	// 	});

	// 	// DEBUG: Log dei risultati
	// 	// console.log('[DEBUG] filteredRouteLocations:', {
	// 	//   dateRange: `${startDate.value} - ${endDate.value}`,
	// 	//   timestampRange: `${startTimestamp} - ${endTimestamp}`,
	// 	//   totalLocations: routeLocations.value.length,
	// 	//   filteredCount: filtered.length,
	// 	//   percentage: routeLocations.value.length > 0 ?
	// 	//     Math.round((filtered.length / routeLocations.value.length) * 100) + '%' : '0%'
	// 	// });

	// 	// // DEBUG dettagliato: Mostra i primi 3 timestamps
	// 	// if (filtered.length > 0) {
	// 	//   console.log('[DEBUG] Sample filtered timestamps:',
	// 	//     filtered.slice(0, 3).map(loc => ({
	// 	//       timestamp: loc.timestamp,
	// 	//       date: new Date(
	// 	//         (typeof loc.timestamp === 'string' ?
	// 	//          parseInt(loc.timestamp, 10) : loc.timestamp) * 1000
	// 	//       ).toISOString()
	// 	//     }))
	// 	//   );
	// 	// }

	// 	return filtered;
	// });

	function extractVehicleLogs(logs: any[]) {
	  if (!Array.isArray(logs)) return [];
		
	  return logs
	    .filter((item: any) => {
	      const hasTimestamp = item?.timestamp != null;
	      const hasLogText =
	        item?.logs !== null &&
	        item?.logs !== undefined &&
	        String(item.logs).trim() !== "";
			
	      return hasTimestamp && hasLogText;
	    })
	    .map((item: any) => ({
	      id: item.id,
	      vin: item.vin,
	      timestamp: Number(item.timestamp),
	      logs: String(item.logs).trim(),
	    }))
	    .sort((a, b) => b.timestamp - a.timestamp);
	}

	// Helper function
	function formatDateDisplay(dateStr: string, forLogs?: boolean): string {
		if (!dateStr) return "";
		const date = new Date(dateStr);
		if (forLogs) {
			const ts = typeof dateStr === "string" ? parseInt(dateStr, 10) : dateStr;
  		if (isNaN(ts)) return "N/D";
			return new Date(ts * 1000).toLocaleString("it-IT", {
  		  day: "2-digit",
  		  month: "2-digit",
  		  year: "numeric",
  		  hour: "2-digit",
  		  minute: "2-digit",
  		});
		}
		return date.toLocaleDateString("it-IT", {
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
		});
	}

	const activityDates = computed(() => {
		// 1. Always include selectedDate if present
		const dates = new Set<string>();
		if (startDate.value) dates.add(startDate.value);
		if (endDate.value) dates.add(endDate.value);
		// 2. Derive dates from loaded historicalData (for ranges like 7d/30d)
		// This will show which days have data in the calendar
		if (historicalData.value && historicalData.value.length > 0) {
			historicalData.value.forEach((d) => {
				if (d.timestamp) {
					// Convert timestamp (seconds) to YYYY-MM-DD
					const dateStr = new Date(d.timestamp * 1000).toISOString().split("T")[0];
					dates.add(dateStr);
				}
			});
		}

		// 3. Also check routeLocations for current loaded route
		if (routeLocations.value && routeLocations.value.length > 0) {
			routeLocations.value.forEach((loc) => {
				if (loc.timestamp) {
					const dateStr = new Date(loc.timestamp * 1000).toISOString().split("T")[0];
					dates.add(dateStr);
				}
			});
		}

		return Array.from(dates);
	});

	// Computed
	const currentLocation = computed<[number, number] | undefined>(() => {
		if (latestData.value?.latitude && latestData.value?.longitude) {
			return [latestData.value.latitude, latestData.value.longitude] as [number, number];
		}
		return undefined;
	});

	// Fetch device data con tracks
	async function fetchDeviceData() {
		try {
			if (!deviceId.value) return;
			loading.value = true;
			const deviceRes = await axios.get(`/devices/${deviceId.value}/get-graph`);
			console.log("DeviceRes data:", deviceRes.data);

			deviceName.value = deviceRes.data?.name || "";
			apiStatus.value = deviceRes.data?.status || "offline";

			// Estrai la lista dei tracks/VIN
			const tracks = deviceRes.data?.track_sat_data || [];
			availableVins.value = tracks.map((track: any) => ({
				vin: track.vin,
			}));

			// console.log("VIN disponibili:", availableVins.value);
			// console.log("VIN selezionat numerico:", selectedVin.value.length);
			// console.log("Selezionato VIN:", selectedVin.value);

			// Seleziona il primo VIN se disponibile e non ne è già selezionato uno
			if (availableVins.value.length > 0 && !selectedVin.value) {
				selectedVin.value = availableVins.value[0].vin;
				// console.log("Selezionato VIN di default:", selectedVin.value);
				await fetchTelemetryData();
				// await fetchHistoricalData(); // <-- Carica anche i dati storici iniziali
				await refreshTimeWindow();
			}
		} catch (error) {
			console.error("Errore fetch dati device:", error);
			toast.error("Errore nel caricamento dati dispositivo", {
				position: "top-right",
			});
		} finally {
			loading.value = false;
		}
	}

	// Fetch dati telemetria PER OVERVIEW (ultimi 100 record)
	async function fetchTelemetryData() {
		if (!selectedVin.value) {
			latestData.value = null;
			toast.warning("Seleziona un VIN per visualizzare i dati", {
				position: "top-right",
			});
			return;
		}

		loading.value = true;
		//console.log(
		//  "[TelemetryPage] fetchTelemetryData started for VIN:",
		//  selectedVin.value
		//);

		try {
			// 1. Fetch ultimi 100 record per overview
			// console.log("[TelemetryPage] Fetching latest logs...");
			if (!deviceId.value) return;
			// console.log("deviceId:", deviceId.value);
			// console.log("selectedVin:", selectedVin.value);
			const chartRes = await axios.get(`/track/${deviceId.value}/logs`, {
				params: {
					limit: 100,
					vin: selectedVin.value,
					orderBy: "timestamp",
					orderDirection: "DESC",
				},
			});
			// console.log("ChartRes data:", chartRes.data);

			//console.log(
			//  "[TelemetryPage] Logs response:",
			//  chartRes.data?.logs?.length,
			//  "logs"
			//);

			if (chartRes.data?.logs?.length) {
				// Filtra record con dati nulli
				const filteredLogs = chartRes.data.logs.filter((log: any) => {
					const hasData = log.vehicle_speed !== null || log.engine_rpm !== null || log.fuel_level !== null || log.engine_temperature !== null || log.tracker_battery !== null || (log.latitude !== null && log.longitude !== null);
					// console.log("[TelemetryPage] Log", log.timestamp, "has data:", hasData);
					return hasData;
				});

				// console.log(
				//   "[TelemetryPage] Filtered logs:",
				//   filteredLogs.length,
				//   "valid logs"
				// );

				if (filteredLogs.length > 0) {
					// chartData.value = filteredLogs; // Rimosso

					// Prepara locations per la mappa
					const logs = filteredLogs.length > 0 ? filteredLogs : chartRes.data.logs;

					// Aggiorna latestData
					latestData.value = logs[0];
					console.log("Latest data:", latestData.value);

					// Aggiorna routeLocations per la mappa
					// Mappatura dati
					// const newRouteLocations = logs.map((d: any) => ({
					// 	lat: d.latitude,
					// 	lng: d.longitude,
					// 	timestamp: d.timestamp,
					// 	speed: d.vehicle_speed,
					// 	rpm: d.engine_rpm,
					// 	fuel: d.fuel_level,
					// 	vin: d.vin,
					// }));

					// Ordina ASC (Oldest -> Newest) per la mappa
					// newRouteLocations.reverse();

					// LOGICA PRESERVAZIONE STORICO:
					// Se abbiamo caricato molti punti (es. > 200, storico giornaliero) e l'aggiornamento è parziale (es. 100 punti del polling),
					// NON sovrascrivere tutto ma aggiungi solo i punti nuovi in coda.
					// if (routeLocations.value.length > 200 && newRouteLocations.length <= 150) {
					// 	const lastCurrent = routeLocations.value[routeLocations.value.length - 1];
					// 	const lastTs = typeof lastCurrent.timestamp === "string" ? parseInt(lastCurrent.timestamp) : lastCurrent.timestamp;

					// 	// Trova punti in newRouteLocations che sono successivi all'ultimo punto attuale
					// 	const freshPoints = newRouteLocations.filter((p: any) => {
					// 		const pts = typeof p.timestamp === "string" ? parseInt(p.timestamp) : p.timestamp;
					// 		return pts > lastTs;
					// 	});

					// 	if (freshPoints.length > 0) {
					// 		// console.log(
					// 		//   `[TelemetryPage] Appending ${freshPoints.length} new points to history`
					// 		// );
					// 		routeLocations.value.push(...freshPoints);
					// 	} else {
					// 		// console.log('[TelemetryPage] Preserving history, no new points');
					// 	}
					// } else {
					// 	// Comportamento standard: rimpiazza SOLO i punti live
					// 	// Mantieni historicalRouteLocations se esistono
					// 	const freshLivePoints = newRouteLocations; // questi sono i nuovi punti live

					// 	// Mantieni historical + aggiungi nuovi live
					// 	routeLocations.value = [...historicalRouteLocations.value, ...freshLivePoints.filter((newPoint: any) => !historicalRouteLocations.value.some((histPoint) => histPoint.timestamp === newPoint.timestamp))];
					// }

					// Emetti la location al componente padre per i dati meteo
					// if (routeLocations.value.length > 0) {
					// 	const lastLoc = routeLocations.value[routeLocations.value.length - 1]; // Usa l'ultimo punto per il meteo live
					// 	if (lastLoc.lat && lastLoc.lng) {
					// 		emit("location-update", [lastLoc.lat, lastLoc.lng]);
					// 	}
					// }
					if (latestData.value?.latitude != null && latestData.value?.longitude != null) {
					  emit("location-update", [latestData.value.latitude, latestData.value.longitude]);
					}

					// Emetti il timestamp al componente padre per l'header
					if (latestData.value?.timestamp) {
						emit("timestamp-update", latestData.value.timestamp);
					}

					// console.log(
					//   "[TelemetryPage] Route locations loaded:",
					//   routeLocations.value.length,
					//   "points"
					// );

					// Reverse Geocoding se coordinate sono cambiate
					const coordsKey = `${latestData.value.latitude},${latestData.value.longitude}`;
					if (coordsKey !== lastGeocodedCoords.value) {
						fetchAddress(latestData.value.latitude, latestData.value.longitude);
						lastGeocodedCoords.value = coordsKey;
					}

					// console.log("[TelemetryPage] Route locations updated");
				} else {
					// console.log("[TelemetryPage] No valid logs found");
					latestData.value = null;
					// chartData.value = [];
					routeLocations.value.length = 0;
				}
			}

			// 2. Fetch statistiche per VIN specifico
			// console.log("[TelemetryPage] Fetching stats...");
			const statsRes = await axios.get(`/track/${deviceId.value}/logs/stats`, {
				params: { vin: selectedVin.value },
			});

			if (statsRes.data?.stats) {
				stats.value = {
					...statsRes.data.stats,
					unique_vehicles: 1,
				};
				// console.log("[TelemetryPage] Stats loaded");
			}
		} catch (error) {
			console.error("[TelemetryPage] Error fetching telemetry data:", error);
			toast.error("Errore nel caricamento dati telemetria", {
				position: "top-right",
			});
		} finally {
			loading.value = false;
			// console.log("[TelemetryPage] fetchTelemetryData completed");
		}
	}

	// Fetch dati storici per range
	// async function fetchHistoricalData(rangeOverride?: string) {
	//   const range = rangeOverride || chartRange.value;

	//   if (!selectedVin.value) {
	//     historicalData.value = [];
	//     return;
	//   }

	//   historicalLoading.value = true;

	//   try {
	//     // 1. DECLARA startTime e endTime
	//     let startTime = 0;
	//     let endTime = Math.floor(Date.now() / 1000); // Default: ora corrente

	//     // 2. CALCOLA in base al range - SOLO UNA VOLTA
	//     if (range === "custom" && selectedDate.value) {
	//       // Custom range con data specifica
	//       const dateObj = new Date(selectedDate.value);
	//       dateObj.setHours(0, 0, 0, 0);
	//       startTime = Math.floor(dateObj.getTime() / 1000);

	//       const endDateObj = new Date(selectedDate.value);
	//       endDateObj.setHours(23, 59, 59, 999);
	//       endTime = Math.floor(endDateObj.getTime() / 1000);
	//     } else {
	//       // Preset ranges (1h, 24h, 7d, 30d) - usa ora corrente come riferimento
	//       switch (range) {
	//         case "1h":
	//           startTime = endTime - 60 * 60;
	//           break;
	//         case "24h":
	//           startTime = endTime - 24 * 60 * 60;
	//           break;
	//         case "7d":
	//           startTime = endTime - 7 * 24 * 60 * 60;
	//           break;
	//         case "30d":
	//           startTime = endTime - 30 * 24 * 60 * 60;
	//           break;
	//         default:
	//           startTime = endTime - 24 * 60 * 60; // default 24h
	//       }
	//     }

	//     // 3. DEBUG LOG (opzionale)
	//     console.log("[TelemetryPage] Historical timeframe:", {
	//       range,
	//       startTime,
	//       endTime,
	//       startDate: new Date(startTime * 1000).toISOString(),
	//       endDate: new Date(endTime * 1000).toISOString(),
	//       rangeSeconds: endTime - startTime,
	//     });

	//     // 4. CHIAMATA API
	//     const historicalRes = await axios.get(`/track/${deviceId.value}/logs`, {
	//       params: {
	//         limit: range === "custom" ? 2000 : 500,
	//         vin: selectedVin.value,
	//         startTime: startTime.toString(),
	//         endTime: endTime.toString(),
	//         orderBy: "timestamp",
	//         orderDirection: "ASC",
	//       },
	//     });

	//     // Modifica la parte del debug (riga dopo la chiamata axios):
	//     console.log(`[DEBUG] Range: ${range}`);
	//     console.log(
	//       `[DEBUG] Record ricevuti: ${historicalRes.data?.logs?.length || 0}`
	//     );

	//     if (historicalRes.data?.logs?.length) {
	//       console.log(
	//         `[DEBUG] Primo timestamp: ${
	//           historicalRes.data.logs[0].timestamp
	//         } (${new Date(
	//           historicalRes.data.logs[0].timestamp * 1000
	//         ).toISOString()})`
	//       );
	//       console.log(
	//         `[DEBUG] Ultimo timestamp: ${
	//           historicalRes.data.logs[historicalRes.data.logs.length - 1].timestamp
	//         } (${new Date(
	//           historicalRes.data.logs[historicalRes.data.logs.length - 1]
	//             .timestamp * 1000
	//         ).toISOString()})`
	//       );

	//       const first = historicalRes.data.logs[0].timestamp;
	//       const last =
	//         historicalRes.data.logs[historicalRes.data.logs.length - 1].timestamp;
	//       const daysCovered = (last - first) / 86400;
	//       console.log(`[DEBUG] Giorni coperti nei dati: ${daysCovered.toFixed(2)}`);
	//     }

	//     // 5. PROCESSO DATI (mantieni il resto uguale...)
	//     if (historicalRes.data?.logs?.length) {
	//       // Filtra e processa i dati per i grafici
	//       const filteredHistoricalLogs = historicalRes.data.logs.filter(
	//         (log: any) => {
	//           return (
	//             log.timestamp &&
	//             (log.vehicle_speed !== null ||
	//               log.engine_rpm !== null ||
	//               log.fuel_level !== null ||
	//               log.engine_temperature !== null ||
	//               log.engine_load !== null)
	//           );
	//         }
	//       );

	//       if (filteredHistoricalLogs.length > 0) {
	//         const sortedLogs = [...filteredHistoricalLogs].sort((a, b) => {
	//           const tsA =
	//             typeof a.timestamp === "string"
	//               ? parseInt(a.timestamp, 10)
	//               : a.timestamp;
	//           const tsB =
	//             typeof b.timestamp === "string"
	//               ? parseInt(b.timestamp, 10)
	//               : b.timestamp;
	//           return tsA - tsB;
	//         });

	//         historicalData.value = sortedLogs;

	//         // AGGIORNAMENTO ROTTA
	//         const newRouteLocations = sortedLogs
	//           .filter((d: any) => d.latitude && d.longitude)
	//           .map((d: any) => ({
	//             lat: d.latitude,
	//             lng: d.longitude,
	//             timestamp: d.timestamp,
	//             speed: d.vehicle_speed,
	//             rpm: d.engine_rpm,
	//             fuel: d.fuel_level,
	//             vin: d.vin,
	//           }));

	//         if (newRouteLocations.length > 0) {
	//           historicalRouteLocations.value = newRouteLocations;

	//           // Combina: storici + punti live (che non sono già negli storici)
	//           const freshPoints = getFreshLivePoints();
	//           routeLocations.value = [
	//             ...historicalRouteLocations.value,
	//             ...freshPoints,
	//           ];

	//           console.log(
	//             `[TelemetryPage] Combined route: ${historicalRouteLocations.value.length} historical + ${freshPoints.length} live points`
	//           );
	//         }
	//       } else {
	//         historicalData.value = [];
	//       }
	//     } else {
	//       // Fallback: prova a recuperare TUTTI i dati del VIN
	//       const allDataRes = await axios.get(`/track/${deviceId.value}/logs`, {
	//         params: {
	//           limit: 500,
	//           vin: selectedVin.value,
	//           orderBy: "timestamp",
	//           orderDirection: "ASC",
	//         },
	//       });

	//       if (allDataRes.data?.logs?.length) {
	//         historicalData.value = allDataRes.data.logs;
	//       } else {
	//         historicalData.value = [];
	//       }
	//     }
	//   } catch (error) {
	//     console.error("[TelemetryPage] Error fetching historical data:", error);
	//     toast.error("Errore nel caricamento dati storici", {
	//       position: "top-right",
	//     });
	//     historicalData.value = [];
	//   } finally {
	//     historicalLoading.value = false;
	//   }
	// }
	async function fetchLastTimestampFromDB(): Promise<number | null> {
	  try {
	    const lastRecordRes = await axios.get(`/track/${deviceId.value}/logs`, {
	      params: {
	        vin: selectedVin.value,
	        limit: 1,
	        orderBy: "timestamp",
	        orderDirection: "DESC",
	      },
	    });

	    const ts = lastRecordRes.data?.logs?.[0]?.timestamp;
	    return ts ? Number(ts) : null;
	  } catch (err) {
	    console.warn("[DEBUG] Could not fetch last timestamp:", err);
	    return null;
	  }
	}

	async function fetchChart(rangeOverride?: string, lastTs?: number | null) {
	  if (!selectedVin.value || !deviceId.value) {
	    historicalData.value = [];
	    return;
	  }

	  const range = rangeOverride || chartRange.value;

	  // const lastTs = await fetchLastTimestampFromDB();
	  const { startTime, endTime } = computeTimeWindow(range, lastTs ?? undefined);

	  const metricMap: Record<string, string> = {
	    speed: "vehicle_speed",
	    rpm: "engine_rpm",
	    temperature: "engine_temperature",
	    fuel: "fuel_level",
	    load: "engine_load",
	    battery: "tracker_battery",
	  };
	  const metric = metricMap[selectedMetric.value] || "vehicle_speed";

	  const maxPointsByRange: Record<string, number> = {
	    "1h": 1000,
	    "24h": 2880,
	    "7d": 3360,
	    "30d": 3600,
	    custom: 1500,
	  };
	  const maxPoints = maxPointsByRange[range] ?? 500;

	  const shouldDownsample = ["7d", "30d", "custom"].includes(range);

	  const res = await axios.get(`/track/${deviceId.value}/logs`, {
	    params: {
	      vin: selectedVin.value,
	      orderBy: "timestamp",
	      orderDirection: "ASC",
	      startTime: String(startTime),
	      endTime: String(endTime),
	      downsample: shouldDownsample ? "true" : "false",
	      maxPoints,
	      metric,
	      strategy: "graph",
	      limit: shouldDownsample ? 50000 : 5000,
	    },
	  });
		
		const metaTR = res.data?.metadata?.timeRange;

		// se l'API te lo manda, usa quello
		if (metaTR?.start != null && metaTR?.end != null) {
		  chartTimeRange.value = { start: Number(metaTR.start), end: Number(metaTR.end) };
		} else {
		  // fallback: usa la finestra calcolata client-side
		  chartTimeRange.value = { start: startTime, end: endTime };
		}

	  const logs = res.data?.logs || [];
	  historicalData.value = logs.filter((l: any) => l?.timestamp != null);
		vehicleLogs.value = extractVehicleLogs(logs);
	}

	async function fetchRoute(rangeOverride?: string, lastTs?: number | null) {
	  if (!selectedVin.value || !deviceId.value) {
	    routeLocations.value = [];
	    return;
	  }

	  const range = rangeOverride || chartRange.value;

	  // const lastTs = await fetchLastTimestampFromDB();
	  const { startTime, endTime } = computeTimeWindow(range, lastTs ?? undefined);

	  // Max points rotta: puoi tenerli alti, la mappa regge ~1k-2k senza morire
	  const routeMaxPointsByRange: Record<string, number> = {
	    "1h": 400,
	    "24h": 800,
	    "7d": 1200,
	    "30d": 1500,
	    custom: 1200,
	  };
	  const maxPoints = routeMaxPointsByRange[range] ?? 800;

	  const shouldDownsample = ["7d", "30d", "custom"].includes(range);

	  const res = await axios.get(`/track/${deviceId.value}/logs`, {
	    params: {
	      vin: selectedVin.value,
	      orderBy: "timestamp",
	      orderDirection: "ASC",
	      startTime: String(startTime),
	      endTime: String(endTime),
	      downsample: shouldDownsample ? "true" : "false",
	      maxPoints,
	      strategy: "route",
	      limit: shouldDownsample ? 50000 : 5000,
	    },
	  });

	  const logs = res.data?.logs || [];
		console.log("veri logs", res.data);

	  routeLocations.value = logs
	    .filter((d: any) => d?.latitude != null && d?.longitude != null && d?.timestamp != null)
	    .map((d: any) => ({
	      lat: d.latitude,
	      lng: d.longitude,
	      timestamp: d.timestamp,
	      speed: d.vehicle_speed,
	      rpm: d.engine_rpm,
	      fuel: d.fuel_level,
	      vin: d.vin,
	    }));
	}

	async function refreshTimeWindow(rangeOverride?: string) {
	  const r = rangeOverride || chartRange.value;
	  historicalLoading.value = true;
	  try {
			const lastTs = await fetchLastTimestampFromDB();
	    await Promise.all([fetchChart(r, lastTs), fetchRoute(r, lastTs)]);
	  } finally {
	    historicalLoading.value = false;
	  }
	}

	// async function fetchHistoricalData(rangeOverride?: string, isSingleDateMode?: Boolean) {
	// 	const range = rangeOverride || chartRange.value;
	// 	console.log("range in fetchHistoricalData:", range);

	// 	if (!selectedVin.value) {
	// 		historicalData.value = [];
	// 		return;
	// 	}

	// 	historicalLoading.value = true;

	// 	try {
	// 		// 1. PRIMA recupera l'ultimo timestamp disponibile per questo VIN
	// 		let lastTimestampFromDB = null;
	// 		try {
	// 			const lastRecordRes = await axios.get(`/track/${deviceId.value}/logs`, {
	// 				params: {
	// 					vin: selectedVin.value,
	// 					limit: 1,
	// 					orderBy: "timestamp",
	// 					orderDirection: "DESC",
	// 				},
	// 			});
	// 			console.log("lastrecordRes data:", lastRecordRes.data?.logs?.[0]?.timestamp);

	// 			if (lastRecordRes.data?.logs?.[0]?.timestamp) {
	// 				lastTimestampFromDB = lastRecordRes.data.logs[0].timestamp;
	// 				console.log(`[DEBUG] Last timestamp from DB:`, {
	// 				  timestamp: lastTimestampFromDB,
	// 				  date: new Date(lastTimestampFromDB * 1000).toISOString()
	// 				});
	// 			}
	// 		} catch (err) {
	// 			console.warn("[DEBUG] Could not fetch last timestamp:", err);
	// 		}

	// 		// 2. CALCOLA startTime e endTime
	// 		let startTime = 0;
	// 		let endTime = lastTimestampFromDB || Math.floor(Date.now() / 1000); // Usa DB timestamp se disponibile

	// 		// 2. CALCOLA in base al range - SOLO UNA VOLTA
	// 		if (range === "custom") {
  //       console.log("arrivo in range custom con date:? e sono presenti startdate.value e enddate.value?", startDate.value, endDate.value);
	// 			// RANGE PERSONALIZZATO con due date
	// 			if (endDate.value) {
	// 				const endDateObj = new Date(endDate.value);
	// 				endDateObj.setHours(23, 59, 59, 999);
	// 				endTime = Math.floor(endDateObj.getTime() / 1000);
	// 				if (!isSingleDateMode) {
	// 					const startDateObj = new Date(startDate.value);
	// 					startDateObj.setHours(0, 0, 0, 0);
	// 					startTime = Math.floor(startDateObj.getTime() / 1000);
	
	// 					const endDateObj = new Date(endDate.value);
	// 					endDateObj.setHours(23, 59, 59, 999);
	// 					endTime = Math.floor(endDateObj.getTime() / 1000);
	
	// 					// console.log(`[Custom Range] Dal ${startDate.value} al ${endDate.value}`, {
	// 					//   startTime,
	// 					//   endTime,
	// 					//   startDate: new Date(startTime * 1000).toISOString(),
	// 					//   endDate: new Date(endTime * 1000).toISOString()
	// 					// });
	// 				}
	// 			}
	// 			// else if (selectedDate.value) {
	// 			//   // Backward compatibility: se c'è ancora selectedDate (singola data)
	// 			//   const dateObj = new Date(selectedDate.value);
	// 			//   dateObj.setHours(0, 0, 0, 0);
	// 			//   startTime = Math.floor(dateObj.getTime() / 1000);

	// 			//   const endDateObj = new Date(selectedDate.value);
	// 			//   endDateObj.setHours(23, 59, 59, 999);
	// 			//   endTime = Math.floor(endDateObj.getTime() / 1000);
	// 			// }
	// 		} else {
	// 			// Preset ranges (1h, 24h, 7d, 30d) - usa ora corrente come riferimento
	// 			switch (range) {
	// 				case "1h":
	// 					startTime = endTime - 60 * 60;
	// 					break;
	// 				case "24h":
	// 					// console.log("Calculating startTime for 24h range");
	// 					startTime = endTime - 24 * 60 * 60;
	// 					break;
	// 				case "7d":
	// 					startTime = endTime - 7 * 24 * 60 * 60;
	// 					break;
	// 				case "30d":
	// 					startTime = endTime - 30 * 24 * 60 * 60;
	// 					break;
	// 				default:
	// 					startTime = endTime - 24 * 60 * 60; // default 24h
	// 			}
	// 		}

	// 		// 4. DETERMINA PARAMETRI DOWNSAMPLING
	// 		// Per range lunghi, attiva downsampping automaticamente
	// 		const shouldDownsample = ["7d", "30d", "custom"].includes(range);
	// 		console.log("shoulddownsample:", shouldDownsample);

	// 		// Mappa metriche frontend → backend
	// 		const metricMap: Record<string, string> = {
	// 			speed: "vehicle_speed",
	// 			rpm: "engine_rpm",
	// 			temperature: "engine_temperature",
	// 			fuel: "fuel_level",
	// 			load: "engine_load",
	// 			battery: "tracker_battery",
	// 		};

	// 		const metric = metricMap[selectedMetric.value] || "vehicle_speed";

	// 		// Punti massimi per range (ottimizzati per visualizzazione)
	// 		const maxPointsByRange: Record<string, number> = {
	// 			"1h": 1000, 
	// 			"24h": 2880,
	// 			"7d": 3360, 
	// 			"30d": 3600,
	// 			custom: 1500,
	// 			};

	// 		const maxPoints = maxPointsByRange[range] || 200;

	// 		const params: Record<string, any> = {
	// 			limit: shouldDownsample ? 50000 : 1000,
	// 			vin: selectedVin.value,
	// 			orderBy: "timestamp",
	// 			orderDirection: isSingleDateMode ? "DESC" : "ASC",
	// 			downsample: shouldDownsample ? "true" : "false",
	// 			maxPoints: maxPoints,
	// 			metric: metric,
	// 		};

	// 		// Aggiungi startTime/endTime SEMPRE, anche se sono 0
  //     if (!isSingleDateMode) params.startTime = startTime.toString();
	// 		if (isSingleDateMode) params.strategy = "route";
	// 		// params.startTime = startTime.toString();
	// 		params.endTime = endTime.toString();

	// 		// console.log(`[Frontend DEBUG] Final params:`, params);

	// 		// axios.interceptors.response.use(response => {
	// 		//   console.log('[Axios Response]', {
	// 		//     url: response.config.url,
	// 		//     params: response.config.params,
	// 		//     status: response.status
	// 		//   });
	// 		//   return response;
	// 		// });

	// 		const historicalRes = await axios.get(`/track/${deviceId.value}/logs`, {
	// 			params,
	// 		});

	// 		// console.log(`[TelemetryPage] Risposta API:`, {
	// 		//   success: historicalRes.data?.success,
	// 		//   count: historicalRes.data?.count,
	// 		//   logsLength: historicalRes.data?.logs?.length,
	// 		//   hasData: !!(historicalRes.data?.logs?.length),
	// 		//   range: range,
	// 		// 	startTime: historicalRes.data?.metadata?.startTime,
	// 		// 	endTime: historicalRes.data?.metadata?.endTime,
	// 		// 	downsampled: historicalRes.data?.downsampled || false,
	// 		// });

	// 		// if (historicalRes.data?.logs?.length) {
	// 			// const first = historicalRes.data.logs[0];
	// 			// const last = historicalRes.data.logs[historicalRes.data.logs.length - 1];
	// 			// console.log(`[DEBUG] Statistiche metriche ricevute:`, {
	// 		  // total: historicalRes.data.logs.length,
	// 		  // withMetric: historicalRes.data.logs.filter((l: any) => l[metric] !== null && l[metric] !== undefined).length,
	// 		  // nullMetric: historicalRes.data.logs.filter((l: any) => l[metric] === null || l[metric] === undefined).length,
  // 			//   sampleNullPoints: historicalRes.data.logs
  // 			//     .filter((l: any) => l[metric] === null || l[metric] === undefined)
  // 			//     .slice(0, 3)
  // 			//     .map((l: any) => ({ 
  // 			//       timestamp: new Date(l.timestamp * 1000).toISOString(),
  // 			//       metric: l[metric] 
  // 			//     }))
  // 			// });
	// 			// console.log(`[Frontend DEBUG] Dati ricevuti per il grafico:`, {
  // 			//   total: historicalRes.data.logs.length,
  // 			//   withSpeed: historicalRes.data.logs.filter((l: any) => l.vehicle_speed !== null).length,
  // 			//   dateRange: {
  // 			//     first: historicalRes.data.logs[0] ? 
  // 			//       new Date(historicalRes.data.logs[0].timestamp * 1000).toISOString() : 'N/A',
  // 			//     last: historicalRes.data.logs[historicalRes.data.logs.length - 1] ? 
  // 			//       new Date(historicalRes.data.logs[historicalRes.data.logs.length - 1].timestamp * 1000).toISOString() : 'N/A'
  // 			//   },
  // 			//   // Verifica se ci sono dati del 26 Gennaio
  // 			//   hasJan26Data: historicalRes.data.logs.some((l: any) => 
  // 			//     new Date(l.timestamp * 1000).toISOString().startsWith('2026-01-26')
  // 			//   ),
  // 			//   jan26Data: historicalRes.data.logs
  // 			//     .filter((l: any) => new Date(l.timestamp * 1000).toISOString().startsWith('2026-01-26'))
  // 			//     .slice(0, 3)
  // 			//     .map((l: any) => ({
  // 			//       time: new Date(l.timestamp * 1000).toISOString(),
  // 			//       speed: l.vehicle_speed
  // 			//     }))
  // 			// });
	// 			// console.log(
	// 			//   `[DEBUG] Primo: ${new Date(first.timestamp * 1000).toISOString()}`
	// 			// );
	// 			// console.log(
	// 			//   `[DEBUG] Ultimo: ${new Date(last.timestamp * 1000).toISOString()}`
	// 			// );

	// 			// const daysCovered = (last.timestamp - first.timestamp) / 86400;
	// 			// console.log(`[DEBUG] Giorni coperti: ${daysCovered.toFixed(2)}`);
	// 			// console.log(
	// 			//   `[DEBUG] Downsampled: ${historicalRes.data.downsampled || false}`
	// 			// );
	// 		// }

	// 		// 7. PROCESSO DATI
	// 		if (historicalRes.data?.logs?.length) {
	// 			// Filtra e processa i dati per i grafici
	// 			const filteredHistoricalLogs = historicalRes.data.logs.filter((log: any) => {
	// 				// console.log("filteredhistoricallogs:", filteredHistoricalLogs);
  //         // Accetta dati con la metrica selezionata non nulla
	// 				if (!isSingleDateMode) {
	// 					// const metricValue = log[metric];
	// 					// console.log("log.timestamp e metricValue:", log.timestamp, metricValue);
	// 					return log.timestamp /*&& metricValue !== null && metricValue !== undefined*/;
	// 				}
	// 				return log.timestamp && log.latitude !== null && log.longitude !== null;
	// 			});
	// 			console.log("filteredhistoricallogs dopo:", filteredHistoricalLogs);

	// 			if (filteredHistoricalLogs.length > 0) {
  //         console.log("entro dentro questa condizione di filteredhistoricallogs.length>0");
	// 				// I dati sono già ordinati dal backend, ma assicuriamoci
	// 				const sortedLogs = [...filteredHistoricalLogs].sort((a, b) => {
	// 					const tsA = typeof a.timestamp === "string" ? parseInt(a.timestamp, 10) : a.timestamp;
	// 					const tsB = typeof b.timestamp === "string" ? parseInt(b.timestamp, 10) : b.timestamp;
	// 					return tsA - tsB;
	// 				});

	// 				historicalData.value = sortedLogs;
  //         console.log("historicalData.value dopo il set:", historicalData.value);
	// 				// console.log(
	// 				//   `[DEBUG] Dati pronti per grafico: ${sortedLogs.length} punti`
	// 				// );

	// 				// 8. AGGIORNAMENTO ROTTA (solo se abbiamo dati di posizione)
	// 				// Per la mappa, potremmo volere un downsampling diverso o mantenere più punti
	// 				const newRouteLocations = sortedLogs
	// 					.filter((d: any) => d.latitude && d.longitude)
	// 					.map((d: any) => ({
	// 						lat: d.latitude,
	// 						lng: d.longitude,
	// 						timestamp: d.timestamp,
	// 						speed: d.vehicle_speed,
	// 						rpm: d.engine_rpm,
	// 						fuel: d.fuel_level,
	// 						vin: d.vin,
	// 					}));

	// 				if (newRouteLocations.length > 0) {
	// 					historicalRouteLocations.value = newRouteLocations;

	// 					// Combina: storici + punti live (che non sono già negli storici)
	// 					const freshPoints = getFreshLivePoints();
	// 					routeLocations.value = [...historicalRouteLocations.value, ...freshPoints];

	// 					// console.log(
	// 					//   `[TelemetryPage] Route: ${historicalRouteLocations.value.length} historical + ${freshPoints.length} live points`
	// 					// );

	// 					// Se per la mappa ci sono troppi punti, potremmo applicare un downsampling leggero
	// 					if (routeLocations.value.length > 1000) {
	// 						console.log(`[DEBUG] Route ha ${routeLocations.value.length} punti, applicando downsampling per mappa`);
	// 						// Potresti implementare un downsampling specifico per coordinate
	// 					}
	// 				}
	// 			} else {
	// 				historicalData.value = [];
	// 				// console.warn(`[DEBUG] Nessun dato valido per metrica: ${metric}`);
	// 			}
	// 		} else {
	// 			routeLocations.value = [];
  // 			historicalRouteLocations.value = [];
	// 			// Fallback se l'API non restituisce dati
	// 			console.warn(`[DEBUG] Nessun dato ricevuto dall'API per range: ${range}`);

	// 			// Prova una chiamata più semplice senza downsampling
	// 			try {
	// 				const fallbackRes = await axios.get(`/track/${deviceId.value}/logs`, {
	// 					params: {
	// 						limit: 100,
	// 						vin: selectedVin.value,
	// 						orderBy: "timestamp",
	// 						orderDirection: "ASC",
	// 					},
	// 				});

	// 				if (fallbackRes.data?.logs?.length) {
	// 					historicalData.value = fallbackRes.data.logs;
	// 					// console.log(
	// 					//   `[DEBUG] Fallback: ${fallbackRes.data.logs.length} punti`
	// 					// );
	// 				} else {
	// 					historicalData.value = [];
	// 				}
	// 			} catch (fallbackError) {
	// 				console.error("[DEBUG] Fallback failed:", fallbackError);
	// 				historicalData.value = [];
	// 			}
	// 		}
	// 	} catch (error: any) {
	// 		console.error("[TelemetryPage] Error fetching historical data:", error);

	// 		// Mostra errore specifico per downsampling
	// 		if (error.response?.status === 400 && error.response?.data?.error?.includes("downsample")) {
	// 			toast.error("Errore nel processamento dati, riprova con range più piccolo", {
	// 				position: "top-right",
	// 			});
	// 		} else {
	// 			toast.error("Errore nel caricamento dati storici", {
	// 				position: "top-right",
	// 			});
	// 		}

	// 		historicalData.value = [];
	// 	} finally {
	// 		historicalLoading.value = false;
	// 	}
	// }

	// AGGIUNGI questa funzione:
	// function getFreshLivePoints() {
	//   // Prendi solo i punti molto recenti (ultimi 5 minuti)
	//   const fiveMinutesAgo = Math.floor(Date.now() / 1000) - 300;

	//   if (!routeLocations.value || routeLocations.value.length === 0) return [];

	//   // Filtra i punti già presenti in routeLocations
	//   return routeLocations.value.filter((point) => {
	//     const pointTs =
	//       typeof point.timestamp === "string"
	//         ? parseInt(point.timestamp, 10)
	//         : point.timestamp;

	//     // Solo punti più recenti di 5 minuti E che non sono già in historicalRouteLocations
	//     return (
	//       pointTs > fiveMinutesAgo &&
	//       !historicalRouteLocations.value.some(
	//         (histPoint) => histPoint.timestamp === point.timestamp
	//       )
	//     );
	//   });
	// }

	// function getFreshLivePoints() {
	// 	if (!routeLocations.value || routeLocations.value.length === 0) return [];

	// 	const fiveMinutesAgo = Math.floor(Date.now() / 1000) - 300;

	// 	// Filtra i punti già presenti in routeLocations
	// 	return routeLocations.value.filter((point) => {
	// 		const pointTs = typeof point.timestamp === "string" ? parseInt(point.timestamp, 10) : point.timestamp;

	// 		// Solo punti più recenti di 5 minuti E che non sono già in historicalRouteLocations
	// 		const isFresh = pointTs > fiveMinutesAgo;
	// 		const isNotInHistorical = !historicalRouteLocations.value.some((histPoint) => histPoint.timestamp === point.timestamp);

	// 		return isFresh && isNotInHistorical;
	// 	});
	// }

	// Handler cambio VIN
	// async function onVinChange() {
	// 	if (!selectedVin.value) return;

	// 	routeLocations.value = [];
	// 	historicalRouteLocations.value = [];

	// 	toast.info(`Caricamento dati per VIN: ${selectedVin.value}`, {
	// 		position: "top-right",
	// 		duration: 2000,
	// 	});

	// 	await Promise.all([fetchTelemetryData(), fetchHistoricalData()]);
	// }

	async function onVinChange() {
	  if (!selectedVin.value) return;

	  latestData.value = null;
	  routeLocations.value = [];
	  historicalData.value = [];

	  toast.info(`Caricamento dati per VIN: ${selectedVin.value}`, {
	    position: "top-right",
	    duration: 2000,
	  });

	  await fetchTelemetryData();       // overview / latest
	  await refreshTimeWindow();        // chart + route per finestra corrente
	}

	// Reverse Geocoding (Nominatim)
	async function fetchAddress(lat: number, lon: number) {
		// console.log("Fetching address for coords:", lat, lon);
		try {
			// console.log("Geocoding...", lat, lon);
			const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`);
			// console.log("Geocoding response:", res);
			const data = await res.json();
			if (data && data.address) {
				// Costruisci stringa indirizzo
				const addr = data.address;
				const parts = [];
				if (addr.road) parts.push(addr.road);
				if (addr.house_number) parts.push(addr.house_number);
				if (addr.postcode) parts.push(addr.postcode);
				if (addr.city || addr.town || addr.village) parts.push(addr.city || addr.town || addr.village);

				currentAddress.value = parts.join(", ");
			} else {
				currentAddress.value = "Indirizzo non trovato";
			}
		} catch (e) {
			console.error("Geocoding error:", e);
			currentAddress.value = "";
		}
	}

	// Formattazione timestamp
	function formatTimestamp(timestamp: number) {
		if (!timestamp) return "N/D";
		return new Date(timestamp * 1000).toLocaleString("it-IT");
	}

	// Classi batteria
	function getBatteryClass(level: number) {
		if (level >= 70) return "high";
		if (level >= 30) return "medium";
		return "low";
	}

	// Controlli mappa
	function centerOnMarker() {
		toast.success("Mappa centrata sulla posizione del veicolo.", {
			position: "top-right",
		});
	}

	function openCoordModal() {
		showCoordModal.value = true;
	}

	function closeCoordModal() {
		showCoordModal.value = false;
	}

	async function copyCoords() {
		if (!currentLocation.value) return;
		const txt = `${currentLocation.value[0].toFixed(6)}, ${currentLocation.value[1].toFixed(6)}`;

		try {
			await navigator.clipboard.writeText(txt);
			toast.success("Coordinate copiate!", { position: "top-right" });
		} catch {
			toast.error("Impossibile copiare le coordinate.", {
				position: "top-right",
			});
		}
	}

	// Controlli grafico - MODIFICATO
	// Range management functions
	// function onDateRangeChange() {
	//   // Auto-sync quando cambiano le date
	//   if (startDate.value && endDate.value) {
	//     chartRange.value = "custom";
	//     fetchHistoricalData("custom");
	//     showChartCalendar.value = false; // Chiudi il popover dopo la selezione
	//   }
	// }

	// function applyDateRange() {
	//   if (!isDateRangeValid.value) {
	//     toast.warning("Seleziona un range valido", { position: "top-right" });
	//     return;
	//   }

	//   chartRange.value = "custom";
	//   fetchHistoricalData("custom");
	//   showChartCalendar.value = false;
	// }

	// function clearDateRange() {
	//   startDate.value = "";
	//   endDate.value = "";
	//   chartRange.value = "24h"; // Torna al default
	//   fetchHistoricalData("24h");
	//   showChartCalendar.value = false;
	// }

	function onCalendarRangeSelect(range: { start: string; end: string }) {
		startDate.value = range.start;
		endDate.value = range.end;
		chartRange.value = "custom";
		// fetchHistoricalData("custom");
		refreshTimeWindow("custom");
		showChartCalendar.value = false;
	}

	// function handleRouteMapDateChange(range: { start: string; end: string }) {
	// 	// console.log('[TelemetryPage] Date range selected in RouteMap:', range);

	// 	// Aggiorna le date nel componente padre
	// 	startDate.value = range.start;
	// 	endDate.value = range.end;
	// 	chartRange.value = "custom";

	// 	// Mostra il calendario (opzionale)
	// 	showChartCalendar.value = false;

	// 	// Fetch nuovi dati per il range selezionato
	// 	// fetchHistoricalData("custom");
	// 	refreshTimeWindow("custom");

	// 	toast.info(`Percorso aggiornato: ${range.start} - ${range.end}`, {
	// 		position: "top-right",
	// 		duration: 3000,
	// 	});
	// }

	// Aggiorna anche setChartRange per cancellare il range quando si seleziona un preset
	// async function setChartRange(range: string) {
	// 	chartRange.value = range;

	// 	if (range === "custom") {
	// 		// Se non c'è range selezionato, mostra il calendario
	// 		if (!startDate.value || !endDate.value) {
	// 			showChartCalendar.value = true;
	// 			return;
	// 		}
	// 	} else {
	// 		// Per preset ranges, reset date
	// 		startDate.value = "";
	// 		endDate.value = "";
	// 	}

	// 	await fetchHistoricalData(range);
	// }

	async function setChartRange(range: string) {
	  chartRange.value = range;

	  if (range !== "custom") {
	    startDate.value = "";
	    endDate.value = "";
	    await refreshTimeWindow(range);
	    return;
	  }

	  // custom
	  if (!startDate.value || !endDate.value) {
	    showChartCalendar.value = true;
	    return;
	  }

	  await refreshTimeWindow("custom");
	}

	// Polling
	let pollInterval: any = null;

	function startPolling() {
		stopPolling();
		pollInterval = setInterval(() => {
			if (selectedVin.value) {
				// Aggiorna solo i dati in tempo reale, non quelli storici
				fetchTelemetryData();
			}
		}, 60000); // Aggiorna ogni 60 secondi
	}

	function stopPolling() {
		if (pollInterval) {
			clearInterval(pollInterval);
			pollInterval = null;
		}
	}

	// Watch per cambiamenti del deviceId
	watch(deviceId, async () => {
		if (deviceId.value) {
			await fetchDeviceData();
		}
	});

	// Lifecycle
	onMounted(() => {
		fetchDeviceData();
		startPolling();
	});

	onBeforeUnmount(() => {
		stopPolling();
	});

	// Computed Status Logic
	const computedStatus = computed(() => {
		if (!latestData.value?.timestamp) return apiStatus.value;

		// Parse timestamp
		const ts = typeof latestData.value.timestamp === "string" ? parseInt(latestData.value.timestamp, 10) : latestData.value.timestamp;

		const now = Math.floor(Date.now() / 1000);
		const diff = now - ts;

		// If older than 15 mins (900 seconds) -> MAINTENANCE (orange)
		if (diff > 900) return "maintenance";

		// If very recent (< 2 mins) -> ONLINE (green)
		if (diff < 120) return "online";

		return apiStatus.value;
	});

	// Helper Functions for Delay
	function getDelayLabel(ts: number | string | undefined): string {
		if (!ts) return "N/D";
		const timestamp = typeof ts === "string" ? parseInt(ts, 10) * 1000 : ts * 1000;
		const diff = Date.now() - timestamp;
		const mins = Math.floor(diff / 60000);

		if (mins < 1) return "Live";
		if (mins < 60) return `${mins}m fa`;
		const hours = Math.floor(mins / 60);
		if (hours < 24) return `${hours}h fa`;
		const days = Math.floor(hours / 24);
		return `${days}gg fa`;
	}

	function getDelayClass(ts: number | string | undefined): string {
		if (!ts) return "";
		const timestamp = typeof ts === "string" ? parseInt(ts, 10) * 1000 : ts * 1000;
		const diff = Date.now() - timestamp;
		// 15 minutes = 900000 ms
		return diff > 900000 ? "warn" : "ok";
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["telemetry-container", { 'headless-mode': __props.headless }])
  }, [
    (!__props.headless)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, [
                _createTextVNode(_toDisplayString(deviceName.value || "Device senza nome") + " ", 1),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(StatusDot, { value: computedStatus.value }, null, 8, ["value"]),
                  (latestData.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createTextVNode(_toDisplayString(formatTimestamp(latestData.value?.timestamp)) + " ", 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["delay-badge", getDelayClass(latestData.value?.timestamp)])
                        }, " (" + _toDisplayString(getDelayLabel(latestData.value?.timestamp)) + ") ", 3)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, "ID: " + _toDisplayString(deviceId.value), 1),
                (selectedVin.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _cache[20] || (_cache[20] = _createTextVNode(" | VIN attivo: ", -1)),
                      _createElementVNode("code", null, _toDisplayString(selectedVin.value), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(ViewToggle, {
                id: "toggle-button",
                class: "toggle-icon"
              }),
              _createVNode(NotificationBell, {
                placement: "header",
                deviceId: deviceId.value
              }, null, 8, ["deviceId"]),
              _createElementVNode("button", {
                id: "exit-to-devices",
                class: "btn-exit",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/devices')))
              }, " Esci ")
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "vin-label" }, [
                _createElementVNode("span", null, "Seleziona Veicolo:")
              ], -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedVin).value = $event)),
                onChange: onVinChange,
                class: "custom-select vin-select"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableVins.value, (track) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: track.vin,
                    value: track.vin
                  }, _toDisplayString(track.vin), 9, _hoisted_13))
                }), 128))
              ], 544), [
                [_vModelSelect, selectedVin.value]
              ]),
              _createElementVNode("span", _hoisted_14, _toDisplayString(availableVins.value.length) + " veicoli", 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "btn-refresh",
                onClick: fetchTelemetryData,
                disabled: loading.value || !selectedVin.value
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["refresh-icon", { spinning: loading.value }])
                }, "↻", 2),
                _cache[22] || (_cache[22] = _createTextVNode(" Aggiorna ", -1))
              ], 8, _hoisted_16)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["vin-container", { 'headless-vin': __props.headless }])
    }, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "vin-label" }, [
            _createElementVNode("span", null, "Seleziona Veicolo:")
          ], -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedVin).value = $event)),
            onChange: onVinChange,
            class: "custom-select vin-select"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableVins.value, (track) => {
              return (_openBlock(), _createElementBlock("option", {
                key: track.vin,
                value: track.vin
              }, _toDisplayString(track.vin), 9, _hoisted_19))
            }), 128))
          ], 544), [
            [_vModelSelect, selectedVin.value]
          ]),
          _createElementVNode("span", _hoisted_20, _toDisplayString(availableVins.value.length) + " veicoli", 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            class: "btn-logs",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showVehicleLogs.value = !showVehicleLogs.value)),
            disabled: !vehicleLogs.value.length
          }, [
            _cache[24] || (_cache[24] = _createTextVNode(" Log veicolo ", -1)),
            (vehicleLogs.value.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(vehicleLogs.value.length), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_22),
          (showVehicleLogs.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _cache[25] || (_cache[25] = _createElementVNode("span", null, "Log disponibili", -1)),
                  _createElementVNode("button", {
                    class: "btn-close-logs",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showVehicleLogs.value = false))
                  }, "✕")
                ]),
                (vehicleLogs.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vehicleLogs.value, (logItem) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: logItem.id,
                          class: "vehicle-log-item"
                        }, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("span", _hoisted_28, _toDisplayString(logItem.vin), 1),
                            _createElementVNode("span", _hoisted_29, _toDisplayString(formatDateDisplay(logItem.timestamp, true)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_30, _toDisplayString(logItem.logs), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_31, " Nessun log disponibile "))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("button", {
            class: "btn-refresh",
            onClick: fetchTelemetryData,
            disabled: loading.value || !selectedVin.value
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["refresh-icon", { spinning: loading.value }])
            }, "↻", 2),
            _cache[26] || (_cache[26] = _createTextVNode(" Aggiorna ", -1))
          ], 8, _hoisted_33)
        ])
      ])
    ], 2),
    _createElementVNode("main", _hoisted_34, [
      _createElementVNode("section", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          (_unref(chartVisibility).preferences.value.locationCard)
            ? (_openBlock(), _createBlock(LocationCard, {
                key: 0,
                class: "span-1",
                isEnabled: true,
                deviceName: deviceName.value,
                location: currentLocation.value,
                address: currentAddress.value,
                onRefresh: fetchTelemetryData,
                onCenter: centerOnMarker,
                onOpenModal: openCoordModal
              }, null, 8, ["deviceName", "location", "address"]))
            : _createCommentVNode("", true),
          (_unref(chartVisibility).preferences.value.vehicleStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "card-hdr" }, [
                  _createElementVNode("h3", null, "Stato Veicolo")
                ], -1)),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "status-label" }, "Velocità", -1)),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(latestData.value?.vehicle_speed || 0) + " km/h", 1)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "status-label" }, "RPM Motore", -1)),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(latestData.value?.engine_rpm || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _cache[29] || (_cache[29] = _createElementVNode("span", { class: "status-label" }, "Temperatura", -1)),
                    _createElementVNode("span", _hoisted_44, _toDisplayString(latestData.value?.engine_temperature || 0) + "°C", 1)
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "status-label" }, "Carburante", -1)),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", {
                          class: "fuel-fill",
                          style: _normalizeStyle({ width: `${latestData.value?.fuel_level || 0}%` })
                        }, null, 4)
                      ]),
                      _createElementVNode("span", _hoisted_48, _toDisplayString(latestData.value?.fuel_level || 0) + "%", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _cache[31] || (_cache[31] = _createElementVNode("span", { class: "status-label" }, "Carico Motore", -1)),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(latestData.value?.engine_load || 0) + "%", 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_51, [
            _cache[36] || (_cache[36] = _createElementVNode("div", { class: "card-hdr" }, [
              _createElementVNode("h3", null, "Informazioni Veicolo")
            ], -1)),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "info-label" }, "VIN Selezionato", -1)),
                _createElementVNode("span", _hoisted_54, _toDisplayString(selectedVin.value || "N/D"), 1)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "info-label" }, "Ultimo Aggiornamento", -1)),
                _createElementVNode("span", _hoisted_56, _toDisplayString(formatTimestamp(latestData.value?.timestamp)), 1)
              ]),
              _createElementVNode("div", _hoisted_57, [
                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "info-label" }, "Record Totali", -1)),
                _createElementVNode("span", _hoisted_58, _toDisplayString(stats.value.total_records || 0), 1)
              ])
            ])
          ])
        ])
      ]),
      (_unref(chartVisibility).preferences.value.historicalChart)
        ? (_openBlock(), _createElementBlock("section", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("h2", _hoisted_61, "Grafici Storici - " + _toDisplayString(selectedVin.value), 1)
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedMetric).value = $event)),
                    class: "custom-select metric-select"
                  }, [...(_cache[37] || (_cache[37] = [
                    _createStaticVNode("<option value=\"speed\" data-v-37567af8>Velocità</option><option value=\"rpm\" data-v-37567af8>RPM Motore</option><option value=\"temperature\" data-v-37567af8>Temperatura</option><option value=\"fuel\" data-v-37567af8>Carburante</option><option value=\"load\" data-v-37567af8>Carico Motore</option><option value=\"battery\" data-v-37567af8>Batteria</option>", 6)
                  ]))], 512), [
                    [_vModelSelect, selectedMetric.value]
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["range-btn", { active: chartRange.value === '1h' }]),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (setChartRange('1h')))
                    }, " 1h ", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["range-btn", { active: chartRange.value === '24h' }]),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (setChartRange('24h')))
                    }, " 24h ", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["range-btn", { active: chartRange.value === '7d' }]),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (setChartRange('7d')))
                    }, [...(_cache[38] || (_cache[38] = [
                      _createElementVNode("span", { class: "full-label" }, "7d", -1),
                      _createElementVNode("span", { class: "short-label" }, "7g", -1)
                    ]))], 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["range-btn", { active: chartRange.value === '30d' }]),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (setChartRange('30d')))
                    }, [...(_cache[39] || (_cache[39] = [
                      _createElementVNode("span", { class: "full-label" }, "30d", -1),
                      _createElementVNode("span", { class: "short-label" }, "30g", -1)
                    ]))], 2)
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("button", {
                      class: "date-range-trigger-btn",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (showChartCalendar.value = !showChartCalendar.value)),
                      title: getDateRangeTitle.value
                    }, [
                      _createElementVNode("span", null, _toDisplayString(getDateRangeDisplay.value), 1),
                      _cache[40] || (_cache[40] = _createElementVNode("span", { class: "icon" }, "📅", -1))
                    ], 8, _hoisted_67),
                    (showChartCalendar.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _createVNode(MaterialCalendar, {
                              selectedStartDate: startDate.value,
                              selectedEndDate: endDate.value,
                              activityDates: activityDates.value,
                              onRangeSelect: onCalendarRangeSelect,
                              onClose: _cache[11] || (_cache[11] = ($event: any) => (showChartCalendar.value = false))
                            }, null, 8, ["selectedStartDate", "selectedEndDate", "activityDates"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createVNode(HistoricalChart, {
                  metric: selectedMetric.value,
                  range: chartRange.value,
                  data: historicalData.value,
                  loading: historicalLoading.value,
                  vin: selectedVin.value,
                  timeRange: chartTimeRange.value
                }, null, 8, ["metric", "range", "data", "loading", "vin", "timeRange"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(chartVisibility).preferences.value.routeMap)
        ? (_openBlock(), _createElementBlock("section", _hoisted_71, [
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "section-header-main" }, [
              _createElementVNode("h2", { class: "telemetric-subtitle" }, "Percorso Veicolo")
            ], -1)),
            _createElementVNode("div", _hoisted_72, [
              (_openBlock(), _createBlock(RouteMap, {
                key: `route-map-${selectedVin.value}-${chartRange.value}-${startDate.value}-${endDate.value}`,
                locations: routeLocations.value,
                loading: historicalLoading.value,
                vin: selectedVin.value,
                startDate: startDate.value,
                endDate: endDate.value,
                onDateChange: onCalendarRangeSelect
              }, null, 8, ["locations", "loading", "vin", "startDate", "endDate"]))
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(chartVisibility).preferences.value.environmentSectionVehicle)
        ? (_openBlock(), _createElementBlock("section", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _cache[42] || (_cache[42] = _createElementVNode("h2", { class: "telemetric-subtitle" }, "ENVIRONMENT VALUES", -1)),
              _createElementVNode("button", {
                class: "settings-btn-main",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (showEnvConfig.value = true)),
                title: "Threshold Settings"
              }, [
                _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faSliders) }, null, 8, ["icon"])
              ])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createVNode(EnvironmentSection, {
                "device-id": deviceId.value,
                "device-name": deviceName.value,
                location: currentLocation.value,
                "current-temp-c": __props.currentTempC || 0,
                "outside-hum": __props.outsideHum || 0,
                "last-update-ago": __props.lastUpdateAgo || 'N/D',
                "chart-range": __props.chartRangeMet || '24h',
                "series-t": __props.seriesT || [],
                "series-h": __props.seriesH || [],
                "temp-min": __props.tempMin,
                "temp-max": __props.tempMax,
                "hum-min": __props.humMin,
                "hum-max": __props.humMax,
                "show-map": false,
                loading: loading.value || __props.meteoLoading,
                onRefresh: _cache[13] || (_cache[13] = ($event: any) => (emit('refresh'))),
                onCenter: _cache[14] || (_cache[14] = ($event: any) => (emit('center'))),
                onCopyCoords: _cache[15] || (_cache[15] = ($event: any) => (emit('copy-coords'))),
                "onUpdate:range": _cache[16] || (_cache[16] = ($event: any) => (emit('update:range', $event)))
              }, null, 8, ["device-id", "device-name", "location", "current-temp-c", "outside-hum", "last-update-ago", "chart-range", "series-t", "series-h", "temp-min", "temp-max", "hum-min", "hum-max", "loading"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(chartVisibility).preferences.value.statisticsPanel)
        ? (_openBlock(), _createElementBlock("section", _hoisted_76, [
            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "section-header-main" }, [
              _createElementVNode("h2", { class: "telemetric-subtitle" }, "Statistiche e Analisi")
            ], -1)),
            _createElementVNode("div", _hoisted_77, [
              _createVNode(StatisticsPanel, {
                stats: stats.value,
                latestData: latestData.value,
                vin: selectedVin.value,
                availableVins: availableVins.value
              }, null, 8, ["stats", "latestData", "vin", "availableVins"])
            ])
          ]))
        : _createCommentVNode("", true),
      (showEnvConfig.value)
        ? (_openBlock(), _createBlock(EnvironmentConfigModal, {
            key: 4,
            "device-id": deviceId.value,
            onClose: _cache[17] || (_cache[17] = ($event: any) => (showEnvConfig.value = false)),
            onSaved: _cache[18] || (_cache[18] = ($event: any) => (emit('refresh')))
          }, null, 8, ["device-id"]))
        : _createCommentVNode("", true)
    ]),
    (showCoordModal.value)
      ? (_openBlock(), _createBlock(LocationModal, {
          key: 1,
          deviceName: deviceName.value,
          deviceId: deviceId.value,
          location: currentLocation.value,
          vin: selectedVin.value,
          onClose: closeCoordModal,
          onCopy: copyCoords,
          onSaved: _cache[19] || (_cache[19] = (loc) => { currentLocation.value = loc; closeCoordModal(); })
        }, null, 8, ["deviceName", "deviceId", "location", "vin"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})